// - In Figma: Prefix all spacing variables with 'space-' and replace underscores with hyphens
//  - In Code: Use camelCase with underscores
//  - Example:
//    - Code: fix_100 -> Figma: space-fix-100
const base = 8

export const fixedSpacings = {
  /** 0px  */ fix_0: 0,
  /** 2px  */ fix_025: `${base * 0.25}px`,
  /** 4px  */ fix_050: `${base * 0.5}px`,
  /** 6px  */ fix_075: `${base * 0.75}px`,
  /** 8px  */ fix_100: `${base * 1}px`,
  /** 12px */ fix_150: `${base * 1.5}px`,
  /** 16px */ fix_200: `${base * 2}px`,
  /** 20px */ fix_250: `${base * 2.5}px`,
  /** 24px */ fix_300: `${base * 3}px`,
  /** 32px */ fix_400: `${base * 4}px`,
  /** 40px */ fix_500: `${base * 5}px`,
  /** 44px */ fix_550: `${base * 5.5}px`,
  /** 48px */ fix_600: `${base * 6}px`,
  /** 64px */ fix_800: `${base * 8}px`,
  /** 80px */ fix_1000: `${base * 10}px`,
} as const

export const scaleSpacings = {
  /** 2px - 4px    */ scale_025: [`${0.25 * base}px`, '', '', '', `${0.5 * base}px`],
  /** 4px - 8px    */ scale_050: [`${0.5 * base}px`, '', '', '', `${1 * base}px`],
  /** 6px - 12px   */ scale_075: [`${0.75 * base}px`, '', '', '', `${1.5 * base}px`],
  /** 8px - 16px   */ scale_100: [`${1 * base}px`, '', '', '', `${2 * base}px`],
  /** 12px - 24px  */ scale_150: [`${1.5 * base}px`, '', '', '', `${3 * base}px`],
  /** 16px - 32px  */ scale_200: [`${2 * base}px`, '', '', '', `${4 * base}px`],
  /** 20px - 40px  */ scale_250: [`${2.5 * base}px`, '', '', '', `${5 * base}px`],
  /** 24px - 48px  */ scale_300: [`${3 * base}px`, '', '', '', `${6 * base}px`],
  /** 32px - 64px  */ scale_400: [`${4 * base}px`, '', '', '', `${8 * base}px`],
  /** 40px - 80px  */ scale_500: [`${5 * base}px`, '', '', '', `${10 * base}px`],
  /** 48px - 96px  */ scale_600: [`${6 * base}px`, '', '', '', `${12 * base}px`],
  /** 64px - 128px */ scale_800: [`${8 * base}px`, '', '', '', `${16 * base}px`],
  /** 80px - 160px */ scale_1000: [`${10 * base}px`, '', '', '', `${20 * base}px`],
}

const spacing = {
  ...fixedSpacings,
  ...scaleSpacings,

  // Old version
  spacing_label_field: '8px',
  spacing_label_field_desktop: '12px',
  spacing_component: '16px',
  spacing_component_desktop: '24px',
} as const

export const getSpacing = (key: string) => {
  return spacing[key]
}

export default spacing
